import {AfterViewInit, Component, ElementRef, EventEmitter, HostBinding, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Table} from 'primeng/table';
import {TableColumnDef} from '../../../shared/tables/table-column-def';
import {FormControl} from '@angular/forms';
import {Router} from '@angular/router';
import {GeneralService, SnackbarService} from '../../../core/services';

@Component({
    selector: 'pr-unselect-table',
    templateUrl: './unselect-table.component.html',
    styleUrls: ['./unselect-table.component.scss', '../base-table.scss']
})
export class NewUnselectTableComponent implements OnInit, AfterViewInit {

    @HostBinding('class') classes = 'flex flex-grow';


    @ViewChild('tableWrapper', {static: false}) tableWrapper: ElementRef;
    @ViewChild('dt', {static: false}) dt: Table;

    @Input() columnsData: Array<TableColumnDef>;
    @Input() tableData: any[];
    @Input() title: string;
    @Input() tableId: string;

    @Input()
    set customPageSize(value: number) {
        if (value === this.perPage) {
            return;
        }
        this.perPage = value;
    }

    @Output() removeProduct = new EventEmitter();

    @Output() customPageSizeChange = new EventEmitter();

    perPage = 25;

    idFieldName: string;
    filterGlobalControl = new FormControl('');
    columns: TableColumnDef[];

    selected = [];

    showTable = false;

    private selectedField: TableColumnDef = {
        field: 'selectedField',
        columnDef: 'selectedField',
        header: 'Selected',
        showSort: false,
        showSearch: false,
        width: 10
    };

    private removeField: TableColumnDef = {
        field: 'removeField',
        columnDef: 'removeField',
        header: '',
        showSort: false,
        showSearch: false,
        width: 10
    };

    constructor(
        private router: Router,
        public generalService: GeneralService,
        private snackBar: SnackbarService,
    ) {
    }

    ngOnInit(): void {
        const tmpColumns = [].concat(this.columnsData);
        this.idFieldName = tmpColumns.shift().columnDef;

        this.columns = [this.selectedField, ...tmpColumns, this.removeField];

        this.tableId = 'Table_' + this.tableId;
    }

    ngAfterViewInit(): void {
        this.checkAllColumnIfExist();
        this.checkWidths();
    }

    onPage(event) {
        this.customPageSizeChange.emit(event.rows);
    }

    clearGlobalFilter() {
        this.dt.filterGlobal('', 'contains');
        this.filterGlobalControl.reset();
    }

    getTooltip(column: Object, row: any): string {
        try {
            switch (column['type']) {
                case 'date':
                    return row ? this.generalService.parseDate(row) : row;
                    break;
                case 'vat':
                    return row
                        ? this.generalService.parseVAT(row).toFixed(0)
                        : row;
                    break;
                case 'margin':
                    return row
                        ? this.generalService.parseVAT(row).toFixed(1)
                        : row;
                default:
                    break;
            }
            switch (column['suffix']) {
                case 'currency':
                    return row ? row.toFixed(2) : row;
                    break;
                default:
                    return row;
                    break;
            }
        } catch (e) {
            console.log(e);
            console.log('error in type');
        }
    }

    searchByColumn(col: TableColumnDef) {
        this.dt.filter(
            col.searchValue,
            col.field,
            'contains'
        );

        col.searched = true;
    }

    clearSearchByColumn(col: TableColumnDef) {
        col.searchValue = '';
        this.dt.filter(
            col.searchValue,
            col.field,
            'contains'
        );

        col.searched = false;
    }

    removeRow(row) {
        this.selected = this.selected.filter((sel) => sel.Id !== row.Id);
        this.removeProduct.emit(row[this.idFieldName]);
    }

    removeSelectedItems() {
        this.selected.forEach(elem => this.removeRow(elem));
    }

    removeAllItems() {
        this.dt.value.forEach(elem => this.removeRow(elem));
    }

    resetTable() {
        this.dt.clear();
        this.dt.clearState();
        this.showTable = false;

        setTimeout(() => {
            this.showTable = true;
        }, 0);
    }

    private checkAllColumnIfExist() {
        const tableSettings = JSON.parse(localStorage.getItem(this.tableId));

        if (tableSettings) {
            if (tableSettings.selection) {
                delete tableSettings.selection;
                localStorage.setItem(this.tableId, JSON.stringify({
                    ...tableSettings
                }));
            }

            const columnOrder: string[] = tableSettings.columnOrder;
            const columnsToRemoveIndex: number[] = [];

            const columnsToRemove: string[] = columnOrder.filter((columnName, index) => {
                if (!(!!this.columns.find(col => col.field === columnName))) {
                    columnsToRemoveIndex.push(index);
                    return true;
                }

                return false;
            });

            if (tableSettings.sortField && !(!!this.columnsData.find(col => col.field === tableSettings.sortField))) {
                delete tableSettings.sortField;
                delete tableSettings.sortOrder;

                localStorage.setItem(this.tableId, JSON.stringify({
                    ...tableSettings
                }));
            }

            if (tableSettings.filters && !(!!this.columnsData.find(col => col.field === Object.keys(tableSettings.filters)[0]))) {
                delete tableSettings.filters;

                localStorage.setItem(this.tableId, JSON.stringify({
                    ...tableSettings
                }));
            }

            if (columnsToRemove.length > 0) {
                const oldColumnsWidth = tableSettings.columnWidths.split(',');

                const newColumns = columnOrder.filter((col, index) => {
                    return columnsToRemoveIndex.indexOf(index) === -1;
                });

                const newColumnsWidths = oldColumnsWidth.filter((val, index) => {
                    return columnsToRemoveIndex.indexOf(index) === -1;
                });

                localStorage.setItem(this.tableId, JSON.stringify({
                    ...tableSettings,
                    columnWidths: newColumnsWidths.join(','),
                    columnOrder: newColumns
                }));
            }
        }
    }

    private checkWidths() {
        const tableSettings = JSON.parse(localStorage.getItem(this.tableId));

        if (tableSettings && this.tableWrapper) {
            // setTimeout(() => {
            const tableWidth = this.tableWrapper.nativeElement.offsetWidth;
            const oldColumnsWidth = tableSettings.columnWidths.split(',');
            const columnWidth = oldColumnsWidth.reduce((a, b) => a + parseInt(b), 0);

            if (tableWidth < columnWidth) {
                const totalLengthToCut = columnWidth - tableWidth + 40;

                const newColumnsWidth = oldColumnsWidth.map((val: string) => {
                    const percentColumn = Math.round((parseInt(val) * 100) / columnWidth);
                    const lengthToCut = Math.round((totalLengthToCut * percentColumn) / 100);
                    return (parseInt(val) - lengthToCut);
                });

                localStorage.setItem(this.tableId, JSON.stringify({
                    ...tableSettings,
                    columnWidths: newColumnsWidth.join(',')
                }));
            }
        }

        setTimeout(() => {
            this.showTable = true;
        }, 0);
    }
}
